import { fetchConfig } from "@theme/utilities";
import { morphSection } from "@theme/section-renderer";
import { CartUpdateEvent, CartGroupedSections } from "@theme/events";

const BANNER_SELECTOR = ".we-site-cart-gift-banner";
const ADD_BUTTON_SELECTOR = "[data-we-site-cart-gift-add]";

/**
 * @param {string} sectionId
 * @returns {string[]}
 */
function gatherSectionIds(sectionId) {
  const sections = [];
  document.dispatchEvent(new CartGroupedSections(sections));
  document.querySelectorAll("cart-items-component").forEach((el) => {
    if (el instanceof HTMLElement && el.dataset.sectionId) {
      sections.push(el.dataset.sectionId);
    }
  });
  if (sectionId) sections.push(sectionId);
  return [...new Set(sections.filter(Boolean))];
}

/**
 * @param {HTMLElement} root
 * @param {number} variantId
 */
async function addGift(root, variantId) {
  const sectionId = root.dataset.sectionId || "";
  const body = {
    items: [
      {
        id: variantId,
        quantity: 1,
        properties: {
          _cart_gwp: "true",
          _cart_gwp_banner: root.dataset.bannerKey || "",
          _free_gift: "true",
        },
      },
    ],
    sections: gatherSectionIds(sectionId).join(","),
    sections_url: window.location.pathname,
  };

  const res = await fetch(FoxTheme.routes.cart_add_url, fetchConfig("json", { body: JSON.stringify(body) }));
  const parsed = await res.json();

  if (parsed?.status && parsed?.message && !parsed?.items && !parsed?.sections) {
    throw new Error(parsed.description || parsed.message || "Gift add failed");
  }

  if (parsed?.sections) {
    for (const sid of Object.keys(parsed.sections)) {
      await morphSection(sid, parsed.sections[sid]);
    }
  }

  document.dispatchEvent(
    new CartUpdateEvent(parsed, sectionId, {
      source: "we-site-cart-gift-banner",
      itemCount: parsed?.item_count,
      sections: parsed?.sections,
    })
  );
}

/**
 * Delegated so the button keeps working after the cart drawer is re-rendered,
 * which can happen before any cart event listener runs.
 * @param {MouseEvent} event
 */
async function onClick(event) {
  const target = event.target instanceof Element ? event.target : null;
  const button = target?.closest(ADD_BUTTON_SELECTOR);
  if (!(button instanceof HTMLButtonElement) || button.disabled) return;

  const root = button.closest(BANNER_SELECTOR);
  if (!(root instanceof HTMLElement)) return;

  const variantId = Number(root.dataset.giftVariantId);
  if (!variantId) return;

  button.disabled = true;
  try {
    await addGift(root, variantId);
  } catch (error) {
    console.error("[we-site-cart-gift-banner]", error);
    button.disabled = false;
  }
}

document.addEventListener("click", onClick);
